var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "form-prepo-et w-form",
    attrs: {
      "id": "client-profile"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveClient.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.errors, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error.join("\n")) + " ")]);
  }), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeSection === 'personal',
      expression: "activeSection === 'personal'"
    }],
    staticClass: "client-data-section"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.firstName,
      expression: "form.firstName"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "firstName",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "firstName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.lastName,
      expression: "form.lastName"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "lastName",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "lastName", $event.target.value);
      }
    }
  })]), _vm.wrongEmail ? _c('div', {
    staticClass: "red--text d-flex justify-content-center mb-1"
  }, [_vm._v("Emailová adresa je už zabratá.")]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "email",
      "type": "email",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.telNumber,
      expression: "form.telNumber"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "telNumber",
      "type": "tel",
      "pattern": "\\+4219\\d{8}",
      "oninvalid": "this.setCustomValidity('Zadajte číslo vo formáte +4219XXXXXXXX')",
      "oninput": "this.setCustomValidity('')"
    },
    domProps: {
      "value": _vm.form.telNumber
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "telNumber", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.birthName,
      expression: "form.birthName"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "birthName",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.birthName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "birthName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.dateOfBirth,
      expression: "form.dateOfBirth"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "name": "dateOfBirth",
      "type": "date",
      "max": _vm.todayLong,
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.dateOfBirth
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "dateOfBirth", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Rodné číslo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.birthNumber,
      expression: "form.birthNumber"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "placeOfBirth",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.birthNumber
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "birthNumber", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.placeOfBirth,
      expression: "form.placeOfBirth"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "placeOfBirth",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.placeOfBirth
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "placeOfBirth", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.nationality,
      expression: "form.nationality"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "nationality",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.nationality
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "nationality", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.identityNumber,
      expression: "form.identityNumber"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "identityNumber",
      "type": "text",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.identityNumber
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "identityNumber", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.iban,
      expression: "form.iban"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "name": "iban",
      "type": "text",
      "maxlength": "256",
      "minlength": "8"
    },
    domProps: {
      "value": _vm.form.iban
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "iban", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.identityDocumentExpiration,
      expression: "form.identityDocumentExpiration"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "date",
      "min": _vm.todayLong,
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.identityDocumentExpiration
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "identityDocumentExpiration", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.op_vytvoreny,
      expression: "form.op_vytvoreny"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "date",
      "max": _vm.todayLong,
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.op_vytvoreny
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "op_vytvoreny", $event.target.value);
      }
    }
  })]), _vm._m(12), _c('sidlo-input', {
    attrs: {
      "type": 'house',
      "property-meta": _vm.splitAddressObject('permanent'),
      "always-shown": "",
      "country-dropdown": ""
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event, 'permanent');
      }
    }
  }), _c('div', {
    staticClass: "section-title poniter noselect",
    on: {
      "click": function click($event) {
        _vm.correspondenceAddressShown = !_vm.correspondenceAddressShown;
      }
    }
  }, [_c('div', {
    staticClass: "bold bl-color"
  }, [_vm._v(_vm._s(!_vm.correspondenceAddressShown ? "+ pridať" : "- odobrať") + " korešpondenčnú adresu ")])]), _vm.correspondenceAddressShown ? _c('div', [_c('sidlo-input', {
    attrs: {
      "type": 'house',
      "property-meta": _vm.splitAddressObject('correspondence'),
      "always-shown": "",
      "country-dropdown": ""
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event, 'correspondence');
      }
    }
  })], 1) : _vm._e()], 1), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeSection === 'bonita',
      expression: "activeSection === 'bonita'"
    }],
    staticClass: "client-data-section"
  }, [_vm._m(13), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "bonita-age"
    }
  }, [_vm._v("Vek")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.age,
      expression: "form.age",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "id": "bonita-age",
      "disabled": !!_vm.form.dateOfBirth,
      "type": "number",
      "min": "1",
      "max": "120"
    },
    domProps: {
      "value": _vm.form.age
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "age", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.form.dateOfBirth ? _c('div', {
    staticClass: "field-help"
  }, [_vm._v(" Vypočítaný z dátumu narodenia: " + _vm._s(_vm.calculatedAge) + " rokov ")]) : _vm._e()]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'bonita_rodinny_stav',
      "init-value": _vm.form.maritalStatus,
      "options": _vm.formTemplate.rodinny_stav.choices,
      "normal": "",
      "name": 'Rodinný stav'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'maritalStatus');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'bonita_vzdelanie',
      "init-value": _vm.form.education,
      "options": _vm.formTemplate.vzdelanie.choices,
      "normal": "",
      "name": 'Vzdelanie'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'education');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'bonita_aktualne_byvate',
      "init-value": _vm.form.currentHousing,
      "options": _vm.formTemplate.aktualne_byvate.choices,
      "normal": "",
      "name": 'V súčasnosti bývam v nehnuteľnosti'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'currentHousing');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'bonita_zuzene_bsm',
      "init-value": _vm.form.narrowedBsm,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Zúžené BSM'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'narrowedBsm');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'bonita_osobitny_vztah',
      "init-value": _vm.form.specialBankRelation,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Osobitný vzťah k banke'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'specialBankRelation');
      }
    }
  })], 1), _vm.mortgage ? _c('div', {
    staticClass: "household-children"
  }, [_vm._m(14), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "kids-applicant-only"
    }
  }, [_vm._v("Deti len žiadateľa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kidsApplicantOnly,
      expression: "form.kidsApplicantOnly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "id": "kids-applicant-only",
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kidsApplicantOnly
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kidsApplicantOnly", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.coApplicant ? [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "kids-shared"
    }
  }, [_vm._v("Spoločné deti")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kidsShared,
      expression: "form.kidsShared",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "id": "kids-shared",
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kidsShared
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kidsShared", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "kids-coapplicant-only"
    }
  }, [_vm._v("Deti len spolužiadateľa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kidsCoApplicantOnly,
      expression: "form.kidsCoApplicantOnly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "id": "kids-coapplicant-only",
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kidsCoApplicantOnly
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kidsCoApplicantOnly", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])] : _vm._e(), _c('div', {
    staticClass: "children-total"
  }, [_vm._v("Celkový počet detí: " + _vm._s(_vm.totalChildren))])], 2) : _vm._e()])], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Meno"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Priezvisko"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Email"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Telefón"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Rodné priezvisko"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dátum narodenia"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Miesto narodenia"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Štátna príslušnosť"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Číslo dokladu totožnosti"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("IBAN"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Expirácia dokladu"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dátum vydania dokladu"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "text-small blc-color"
  }, [_vm._v("Adresa trvalého pobytu")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title section-heading"
  }, [_c('div', [_c('div', {
    staticClass: "text-small blc-color"
  }, [_vm._v("Bonita klienta")]), _c('div', {
    staticClass: "light"
  }, [_vm._v("Údaje používané pri výpočte limitov a bankových ponúk.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title section-heading"
  }, [_c('div', [_c('div', {
    staticClass: "text-small blc-color"
  }, [_vm._v("Deti domácnosti")]), _c('div', {
    staticClass: "light"
  }, [_vm._v("Každé dieťa zadajte iba do jednej skupiny.")])])]);

}]

export { render, staticRenderFns }